/** Couleurs et petits contrôles partagés par les figures 2D et 3D du lecteur. */
import type { FigureSpec } from "@jange/shared";

export const C = { ink: "#15213B", muted: "#5B6478", teal: "#0E6B66", tealTint: "#E3F1EF", amber: "#E8A317", amberTint: "#FBEFD9", amberText: "#B86E00", border: "#E6E8EE" };

/** Nombre court à la française : 2,5 · −1 · 12. */
export const fmt = (v: number) => (Math.abs(v) >= 10 ? v.toFixed(0) : v.toFixed(Math.abs(v - Math.round(v)) < 1e-9 ? 0 : 1)).replace("-", "−").replace(".", ",");

type Slider = FigureSpec["sliders"][number];

export function SliderRow({ s, value, lang, onChange, onRelease }: { s: Slider; value: number; lang: string; onChange: (v: number) => void; onRelease?: () => void }) {
  const label = s.label[lang] ?? s.label.fr ?? s.name;
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13, fontWeight: 600 }}>
      <span style={{ display: "flex", justifyContent: "space-between" }}><span>{label}</span><span style={{ color: C.teal }}>{fmt(value)}</span></span>
      <input type="range" min={s.min} max={s.max} step={s.step} value={value} style={{ width: "100%", accentColor: C.teal, height: 32 }}
        aria-label={label} onChange={(e) => onChange(Number(e.target.value))} onPointerUp={onRelease} />
      <span style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#8A93A6", fontWeight: 500 }}><span>{fmt(s.min)}</span><span>{fmt(s.max)}</span></span>
    </label>
  );
}

export const card = { border: `1px solid ${C.border}`, borderRadius: 18, padding: 12, display: "flex", flexDirection: "column", gap: 10, background: "#fff" } as const;
export const chip = { fontSize: 11, fontWeight: 700, color: C.teal, background: C.tealTint, padding: "4px 8px", borderRadius: 999, whiteSpace: "nowrap" } as const;

/** WebGL disponible ? (sinon on montre l'image de secours et les légendes). */
export function hasWebGL() {
  try {
    const c = document.createElement("canvas");
    return !!(c.getContext("webgl2") ?? c.getContext("webgl"));
  } catch { return false; }
}
